// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1_Sy1","alert":"SettungsInbox_alert__20iQE"};